document.addEventListener('DOMContentLoaded', function () {
  const WISHLIST_KEY = 'aakara_wishlist';

  function getWishlist() {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().some(item => item.handle === handle);
  }

  function updateButtonState(btn) {
    const handle = btn.dataset.productHandle;
    if (isInWishlist(handle)) {
      btn.classList.add('is-wishlisted');
      btn.querySelector('.wishlist-text').textContent = 'Remove from Wishlist';
    } else {
      btn.classList.remove('is-wishlisted');
      btn.querySelector('.wishlist-text').textContent = 'Add to Wishlist';
    }
  }

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    updateButtonState(btn);

    btn.addEventListener('click', function () {
      const id = btn.dataset.productId;
      const handle = btn.dataset.productHandle;
      let list = getWishlist();

      if (isInWishlist(handle)) {
        list = list.filter(item => item.handle !== handle);
      } else {
        list.push({ id, handle });
      }

      saveWishlist(list);
      updateButtonState(btn);
    });
  });
});